<template>
  <div>
    <v-progress-circular
      v-if="typeof infoItem[infoSlot.id + '_total_calls'] == 'undefined'"
      :rotate="180"
      :size="24"
      :value="value"
      color="primary"
    >
    </v-progress-circular>

    <subjective-distribution-widget
      v-else-if="scoringRuleDisplay && (infoItem[infoSlot.id + '_insight_metric'] == 0 || infoItem[infoSlot.id + '_insight_metric'] == 1)"
      :scale="50"
      :info="infoItem"
      :display="insightChannelText"
      :type="infoItem[infoSlot.id + '_insight_metric'] == 0 ? 'sentiment': 'emotion'"
      :scorecardAggregates="true"
      :scorecardSlotId="infoSlot.id"
    ></subjective-distribution-widget>

    <score-chip
      v-else-if="infoItem.call_count > 0"
      :score="categoryPercent"
      :calls_modified="infoItem[infoSlot.id + '_calls_modified']"
      :aggregate_cat="true"
      :nonAppCatHandling="nonAppCatHandling"
      :num_not_applicable="infoItem[infoSlot.id + '_num_not_applicable']"
      :total_calls="infoItem[infoSlot.id + '_total_calls']"
      :display_label="infoItem[infoSlot.id + '_insight_category'] == false || !infoItem[infoSlot.id + '_insight_category']"
      :scorecard_insight="scoringRuleDisplay && infoItem[infoSlot.id + '_insight_category'] == true"
    ></score-chip>

  </div>
</template>

<script>
import SubjectiveDistributionWidget from "../../Widgets/SubjectiveDistributionWidget.vue";
import ScoreChip from '../ScoreChip.vue';
export default {
  components: { SubjectiveDistributionWidget, ScoreChip },
  props: {
    infoItem: {
      type: Object,
      required: true
    },
    infoSlot: {
      type: Object
    },
    nonAppCatHandling: {
      type: Number,
      default: 0
    }
  },
  data: () => ({
    value: 0,
    interval: {}
  }),
  computed: {
    categoryPercent() {
      return this.scoringRuleDisplay && this.infoItem[this.infoSlot.id + '_insight_category'] == true 
        ? this.infoItem[this.infoSlot.id + '_insight_percent'] 
        : this.infoItem[this.infoSlot.id]
    },
    scoringRuleDisplay() {
      return this.infoItem[this.infoSlot.id + '_scoring_rule'] == 2
    },
    insightChannelText() {
      switch (this.infoItem[this.infoSlot.id + "_insight_channel"]) {
        case 0:
          return "Agent";
        case 1:
          return "Customer";
        default:
          return "Overall";
      }
    },
  },
  methods: {
    itemChanged() {
      if (
        typeof this.infoItem[this.infoSlot.id + "_total_calls"] != "undefined"
      ) {
        clearInterval(this.interval);
      }
    }
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  mounted() {
    this.interval = setInterval(() => {
      if (this.value >= 100) {
        return (this.value = 0);
      }
      this.value += 25;
    }, 500);
    if (
      typeof this.infoItem[this.infoSlot.id + "_total_calls"] != "undefined"
    ) {
      clearInterval(this.interval);
    }
  },
  watch: {
    infoItem: "itemChanged"
  }
};
</script>

<style scoped></style>
